import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'
import CitasCalendario from '@/views/citas/CitasCalendario'
import CategoriasListado from '@/views/configuraciones/CategoriasListado'
import ConfiguracionesView from '@/views/configuraciones/ConfiguracionesView'
import ImportarForm from '@/views/importar/ImportarForm'
import EscuelasListado from '@/views/escuelas/EscuelasListado'
import EscuelasForm from '@/views/escuelas/EscuelasForm'
import EscuelasDetalle from '@/views/escuelas/EscuelasDetalle'
import EscuelasDetalleContactos from '@/components/escuelas/EscuelasDetalleContactos'
import EscuelaDetalleAlumnos from '@/components/escuelas/EscuelaDetalleAlumnos'
import LegalesListado from '@/views/legales/LegalesListado'
import LegalesForm from '@/views/legales/LegalesForm'
import UsuariosListado from '@/views/usuarios/UsuariosListado'
import UsuariosForm from '@/views/usuarios/UsuariosForm'
import PacientesListado from '@/views/pacientes/PacientesListado'
import PacientesForm from '@/views/pacientes/PacientesForm'
import TamizajeCuestionario from '@/views/tamizaje/TamizajeCuestionario'
import CedulaSospechaCancer from '@/views/cedulas/CedulaSospechaCancer'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/citas',
    name: 'CitasCalendario',
    component: CitasCalendario,
  }, {
    path: '/categorias',
    name: 'CategoriasListado',
    component: CategoriasListado,
  }, {
    path: '/configuracion',
    name: 'ConfiguracionesView',
    component: ConfiguracionesView,
  }, {
    path: '/escuelas',
    name: 'EscuelasListado',
    component: EscuelasListado,
  }, {
    path: '/escuela/:idEscuela?',
    name: 'EscuelasForm',
    component: EscuelasForm,
  },
  // {
  //   path: '/escuela/detalle/:idEsc',
  //   name: 'EscuelasDetalle',
  //   component: EscuelasDetalle,
  //   children: [{
  //     path: 'contactos',
  //     component: EscuelasDetalleContactos,
  //   }, {
  //     path: 'alumnos',
  //     component: EscuelaDetalleAlumnos,
  //   },]
  // },
  {
    path: '/importar/:tipo',
    name: 'ImportarForm',
    component: ImportarForm
  }, {
    path: '/legales',
    name: 'LegalesListado',
    component: LegalesListado
  }, {
    path: '/legal/:idLegal?',
    name: 'LegalesForm',
    component: LegalesForm
  }, {
    path: '/usuarios',
    name: 'UsuariosListado',
    component: UsuariosListado
  }, {
    path: '/usuario/:idUsr?',
    name: 'UsuariosForm',
    component: UsuariosForm
  }, {
    path: '/pacientes',
    name: 'PacientesListado',
    component: PacientesListado
  }, {
    path: '/paciente/:idPac?',
    name: 'PacientesForm',
    component: PacientesForm
  },
  {
    path: '/tamizaje/:idPac?',
    name: 'TamizajeCuestionario',
    component: TamizajeCuestionario
  }, {
    path: '/cedulas/cedula-sospecha-cancer',
    name: 'CedulaSospechaCancer',
    component: CedulaSospechaCancer
  }
  ]
})